<template>
  <div v-if="show" class=" w-1/2 bg-[rgba(93,93,152,0.55)] rounded-lg text-white p-4 text-sm flex flex-col gap-2">
    <div class="flex justify-between">
      <h2 class="text-[#ff9b05]">{{ form_title }}</h2>
      <AppButton  v-bind:visibility="true"  left_icon="fa-regular fa-circle-xmark fa-xl" emitType="close" @close="close" :width=20 :height=20 />
    </div>
    <form @submit.prevent="submitForm">
      <div v-for="(value, key) in form_data" :key="key" class="mb-4">
        <template v-if="shouldRenderField(key)">
          <label class="capitalize mb-8" :for="key">{{ key }}:</label>
          <template
            v-if="getFieldType(value) === 'text' || getFieldType(value) === 'number' || getFieldType(value) === 'password' || getFieldType(value) === 'email'">
            <input v-model="return_data[key]" :type="getFieldType(value)" :id="key" class="form-control"
              @input="updateField(key, $event.target.value)" />
          </template>
          <template v-else-if="getFieldType(value) === 'checkbox'">
            <input v-model="return_data[key]" :type="getFieldType(value)" :id="key" class="form-control"
              @change="updateField(key, $event.target.checked)" />
          </template>
          <template v-else-if="getFieldType(value) === 'date'">
            <input v-model="return_data[key]" type="date" :id="key" class="form-control"
              @input="updateField(key, $event.target.value)" />
          </template>
          <template v-else-if="getFieldType(value) === 'select'">
            <select v-model="return_data[key]" :id="key" class="form-control"
              @change="updateField(key, $event.target.value)">
              <option v-for="option in value" :value="option.id" :key="option">{{ option.nome?option.nome:option.matricula }}</option>
            </select>
          </template>
          <template v-else-if="getFieldType(value) === 'object-checkbox'">
            <div class="flex flex-wrap w-full justify-center gap-2 ">
              <div v-for="(checkboxValue, checkboxKey, index) in value" :key="checkboxKey" class="flex ">
                <div v-if="typeof checkboxValue === 'boolean'" class="flex gap-2 items-center min-w-[200px]">
                  <input v-model="return_data[key][checkboxKey]" type="checkbox" :id="`${key}-${checkboxKey}`"
                  @change="updateField(`${key}.${checkboxKey}`, $event.target.checked)" class="hidden" />
                  <label :for="`${key}-${checkboxKey}`" class="flex items-center cursor-pointer">
                    <span class="w-4 h-4 inline-block mr-1 rounded border border-gray-500 bg-white"></span>
                    {{ checkboxKey }}
                  </label>
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>
      <button type="submit" class="submit-button">
        {{ create_btn ? 'Criar' : (update_btn ? 'Atualizar' : 'Submit') }}
      </button>
    </form>
  </div>
</template>


<script>
import AppButton from './button.vue';

export default {
  name: 'AppForm',
  components: {
    AppButton,
  },
  props: {
    form_data: {
      type: Object,
      default: () => ({}),
    },
    form_title: {
      type: String,
      default: () => 'Table Title',
    },
    show: {
      type: Boolean,
      default: () => true,
    },
    create_btn: {
      type: Boolean,
      default: false,
    },
    update_btn: {
      type: Boolean,
      default: false,
    },
    visibility: {
      type: Boolean,
      default: () => false,
    },
  },
  mounted() {
    this.return_data = { ...this.form_data };
  },
  methods: {
    submitForm() {
      console.log("inside return_data", this.return_data)
      if (this.isValidForm()) {
        if (this.create_btn) {
          console.log(this.return_data)
          this.$emit('create_data', this.return_data);
        } else if (this.update_btn) {
          this.$emit('update_data', this.return_data);
        }
      }
    },
    isValidForm() {
      for (const key in this.return_data) {
        if (this.return_data[key] === '' || this.return_data[key] === null || this.return_data[key] === undefined) {
          return false;
        }
      }
      return true;
    },
    getFieldType(value) {
      if (typeof value === 'number') {
        return 'number';
      } else if (typeof value === 'boolean') {
        return 'checkbox';
      } else if (value instanceof Date) {
        return 'date';
      } else if (this.isEmail(value)) {
        return 'email';
      } else if (typeof value === 'string') {
        return 'text';
      } else if (Array.isArray(value)) {
        return 'select';
      } else if (typeof value === 'object') {
        for (let key in value)
          if (typeof value[key] === 'boolean')
            return 'object-checkbox';
      }
      return 'text';
    },
    getPattern(key) {
      if (key.toLowerCase() === 'email') {
        return '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$';
      }
      return '';
    },
    isEmail(value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(value);
    },
    shouldRenderField(key) {
      return key.toLowerCase() !== 'id';
    },
    updateField(key, value) {
      if (key.includes('.')) {
        let [objectKey, checkboxKey] = key.split('.');
        this.return_data[objectKey][checkboxKey] = value;
      }
      else if (this.getFieldType(this.form_data[key]) === 'select') {
        this.return_data[key] = parseInt(value);
      } else {
        this.return_data[key] = value;
      }
    },
    close() {
      this.$emit('close');
    },
  },
  data() {
    return {
      return_data: { ...this.form_data },
    };
  },
};
</script>

<style scoped>
input[type="checkbox"]:checked + label span {
            background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="yellow"><path d="M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193"></path></svg>') no-repeat center center;
            border-color: #ff9b05;
            border:2px  #ff9b05 solid;
          }
.form-control {
  @apply h-6 flex gap-2 mt-2 rounded-lg w-11/12 px-2 text-black outline-none focus:ring-2 focus:ring-[#2e2e48];
}

.close_btn_div {
  display: flex;
  align-self: flex-end;
  gap: 0.5rem;
}




.submit-button {
  @apply px-4 py-1 bg-sky-600 rounded-lg shadow-lg hover:bg-sky-700;

}
</style>
